import isPlainObject from './isPlainObject';
import flattenWhenNode from './flattenWhenNode';
export default flattenWhenNode(isPlainObject);


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/flattenActionMap.js
// module id = 1446
// module chunks = 1